import { default as consoleEvents } from "@pb/utils/consoleEvents";
const errorHandler = (error) => {
    consoleEvents.error(error.toString());
};
export default errorHandler;
//# sourceMappingURL=errorHandler.js.map